module.exports = __webpack_public_path__ + "static/the-warren-buffett-portfolio-4ea3bd81e7da5f9bf7cb3f7fc393b08f.jpg";